import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=f8d47cb4&scoped=true"
var script = {}
import style0 from "./AboutHeader.vue?vue&type=style&index=0&id=f8d47cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d47cb4",
  null
  
)

export default component.exports